// prettier-ignore
export default (user) => {
	return user.hasOwnProperty("globalRole") && user.globalRole === "master";
};
